module.exports = __webpack_public_path__ + "static/media/codeBallSounds.d8de0b9e.png";